import { render, staticRenderFns } from "./toggleBtns.vue?vue&type=template&id=5a2d07d7&scoped=true&"
import script from "./toggleBtns.vue?vue&type=script&lang=js&"
export * from "./toggleBtns.vue?vue&type=script&lang=js&"
import style0 from "./toggleBtns.vue?vue&type=style&index=0&id=5a2d07d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2d07d7",
  null
  
)

export default component.exports